export var SaveDestination;
(function (SaveDestination) {
    SaveDestination["SiteMedia"] = "site-media";
    SaveDestination["UserMedia"] = "user-media";
})(SaveDestination || (SaveDestination = {}));
//# sourceMappingURL=RenderRequest.js.map